<template>
    <SimpleButton class="nobreak order_button" @click="() => onButtonClick()">
        <SortArrowUp
            :class="['order_icon', column == globalSortColumn && sortDirection == 'asc' ? 'drawn_asc' : 'hidden']" />
        <SortArrowDown
            :class="['order_icon', column == globalSortColumn && sortDirection == 'desc' ? 'drawn_dsc' : 'hidden']" />
        <SortArrowNo :class="['order_icon', column != globalSortColumn ? 'drawn_no_order' : 'hidden']" />
    </SimpleButton>
</template>
<script>
import SortArrowDown from "@/components/svg/SortArrowDown.vue";
import SortArrowNo from "@/components/svg/SortArrowNo.vue";
import SortArrowUp from "@/components/svg/SortArrowUp.vue";
import SimpleButton from "./SimpleButton.vue";

export default {
    name: "SortButton",
    components: {
        SimpleButton,
        SortArrowUp,
        SortArrowDown,
        SortArrowNo,
    },
    data() {
        return {
        };
    },
    props: {
        globalSortColumn: {
            type: String,
            default: '',
        },
        column: {
            type: String,
            default: '',
        },
        sortDirection: {
            type: String,
            default: '',
        },
    },
    methods: {
        onButtonClick() {
            this.$emit('click');
        },
    },
};
</script>
<style scoped>
.drawn_no_order {
    color: #dddddd;
    display: block;
    visibility: visible;
    filter: brightness(1.7);
}

.nobreak {
    white-space: nowrap;
}

.drawn_asc {
    display: block;
    visibility: visible;
    filter: brightness(0.15) sepia(100%) hue-rotate(135deg) saturate(5000%);
}

.drawn_dsc {
    display: block;
    visibility: visible;
    filter: brightness(0.15) sepia(100%) hue-rotate(45deg) saturate(5000%);
}

.order_button {
    background-color: #ffffff00;
    border: 0px solid #ffffff00;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    padding: 0;
}

.order_button:hover {
    border: 0px solid #ffffff00;
}

.order_icon {
    width: 16px;
    height: 16px;
    object-fit: contain;
}

.hidden {
    display: none;
    visibility: hidden;
}
</style>